import gql from 'graphql-tag'

export default gql`
  query getSubjects {
    getSubjects {
      id
      email
      detail {
        label
        title
      }
      parent {
        id
        detail {
          label
          title
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/apollo/graphql/subject/getSubjects.js